import { fetchLists } from './swym.js'

class WishlistSelect extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }

    window.SwymCallbacks.push(() => {
      fetchLists().then(lists => {
        this.populateWishlists(lists)
      })
    })
  }

  setupListeners () {
    super.setupListeners()

    this.toggleExpanded = this.toggleExpanded.bind(this)
    this.selectWishlist = this.selectWishlist.bind(this)

    document.addEventListener('swym:lists-updated', () => {
      this.populateWishlists()
    })

    this.listeners.add(this.trigger, 'click', this.toggleExpanded)
  }

  populateWishlists (lists) {
    lists.forEach(list => {
      const option = document.createElement('option')
      option.value = list.lid
      option.innerText = list.lname

      this.select.appendChild(option)

      const button = document.createElement('button')
      button.classList.add('btn-Button', 'prd-DetailVariants_DropdownOption')
      button.dataset.lid = list.lid
      button.value = list.lname
      button.addEventListener('click', this.selectWishlist)

      const span = document.createElement('span')
      span.classList.add('prd-DetailVariants_VariantLabel')
      span.innerText = list.lname

      button.appendChild(span)

      this.dropdown.appendChild(button)
    })
  }

  toggleExpanded (event) {
    this.setAttribute('aria-expanded', !this.expanded)
  }

  selectWishlist (event) {
    const lid = event.currentTarget.dataset.lid

    this.dataset.lid = lid
    this.dataset.wishlistName = event.currentTarget.innerText
    this.select.value = lid
    this.toggleExpanded()

    if (this.externalEls.variantSelect.element.value) {
      this.externalEls.addToWishList.element.removeAttribute('disabled')
    } else {
      this.externalEls.addToWishList.element.setAttribute('disabled', true)
    }
  }

  get select () {
    return this.els.select.element
  }

  get dropdown () {
    return this.els.dropdown.element
  }

  get expanded () {
    return this.getAttribute('aria-expanded') === 'true'
  }

  get trigger () {
    return this.els.trigger.element
  }
}

if (!customElements.get('wishlist-select')) {
  customElements.define('wishlist-select', WishlistSelect)
}
